import script from "./UsuarioRooming.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioRooming.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioRooming.vue?vue&type=style&index=0&id=812dba72&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-812dba72"]])

export default __exports__